import React, { useState } from 'react'
import { ButtonSelectCourseStyle } from './style'

type ICourses = {
  courseName: string
}

type ButtonSelectCourseProps = React.FC<{
  setCourses: React.Dispatch<React.SetStateAction<ICourses[]>>
  courses: ICourses[]
  text: string
  setValidateCourses: React.Dispatch<React.SetStateAction<boolean>>
}>

export const ButtonSelectCourse: ButtonSelectCourseProps = ({ setCourses, courses, text, setValidateCourses }) => {
  const [isChecked, setIsChecked] = useState(false)

  const deleteCourse = (value: { courseName: string }) => {
    const newArray: ICourses[] = [...courses]
    const searchValue = newArray.findIndex(search => search.courseName === value.courseName)
    if (searchValue !== -1) {
      newArray.splice(searchValue, 1)
      if (newArray.length === 0) {
        newArray.push({ courseName: '' })
        setValidateCourses(false)
      }
      setCourses(newArray)
    }
    setIsChecked(false)
  }

  const addCourse = (value: { courseName: string }) => {
    const emptyArrayCourses = courses.find(course => course.courseName)
    if (typeof emptyArrayCourses === 'undefined') {
      setCourses([value])
      setIsChecked(true)
    } else {
      setCourses([...courses, value])
      setIsChecked(true)
    }
    setValidateCourses(true)
  }

  return (
    <ButtonSelectCourseStyle>
      <button
        className={isChecked ? 'active' : ''}
        onClick={() => (isChecked ? deleteCourse({ courseName: text }) : addCourse({ courseName: text }))}
      >
        {text}
      </button>
    </ButtonSelectCourseStyle>
  )
}
